import * as THREE from 'three'

var Detector = {
    canvas: !!window.CanvasRenderingContext2D,
    webgl: (function() {
        try {
            var canvas = document.createElement('canvas')
            return !!(
                window.WebGLRenderingContext &&
                (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
            )
        } catch (e) {
            return false
        }
    })(),

    Check_Version: function() {
        var rv = -1 // Return value assumes failure.

        if (navigator.appName == 'Microsoft Internet Explorer') {
            var ua = navigator.userAgent,
                re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})')

            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1)
            }
        } else if (navigator.appName == 'Netscape') {
            /// in IE 11 the navigator.appVersion says 'trident'
            /// in Edge the navigator.appVersion does not say trident
            if (navigator.appVersion.indexOf('Trident') !== -1) rv = 11
            else {
                var ua = navigator.userAgent
                var re = new RegExp('Edge/([0-9]{1,}[\\.0-9]{0,})')
                if (re.exec(ua) !== null) {
                    rv = parseFloat(RegExp.$1)
                }
            }
        }

        return rv
    },

    supportVideoTexture: function() {
        //ie 11 and edge 12 doesn't support video texture.
        var version = this.Check_Version()
        return version === -1 || version >= 13
    },
}

export const THREEx = THREEx || {}

THREEx.noVideoTextureSupport = !Detector.supportVideoTexture()

THREEx.VideoTexture = (function() {
    var _videoTexture = THREE.VideoTexture
    var _ieVideoTexture = function(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        if (THREEx.noVideoTextureSupport) {
            var scope = this
            var raf

            scope.video = video
            scope.ctx2d = document.createElement('canvas').getContext('2d')
            var canvas = scope.ctx2d.canvas

            video.onloadedmetadata = function() {
                canvas.width = scope.video.videoWidth
                canvas.height = scope.video.videoHeight
            }

            var originalDispose = scope.dispose

            // override THREEJS texture dispose
            this.dispose = function() {
                cancelAnimationFrame(raf)
                originalDispose.call(scope)
            }

            scope.ctx2d.drawImage(scope.video, 0, 0)
            THREE.Texture.call(
                scope,
                scope.ctx2d.canvas,
                mapping,
                wrapS,
                wrapT,
                magFilter,
                minFilter,
                format,
                type,
                anisotropy
            )

            scope.generateMipmaps = false

            function update() {
                raf = requestAnimationFrame(update)

                if (video.readyState >= video.HAVE_CURRENT_DATA) {
                    scope.ctx2d.drawImage(scope.video, 0, 0)
                    scope.needsUpdate = true
                }
            }

            update()
        }
    }
    return THREEx.noVideoTextureSupport ? _ieVideoTexture : _videoTexture
})()

THREEx.VideoTexture.prototype = Object.create(THREE.Texture.prototype)
THREEx.VideoTexture.prototype.constructor = THREE.VideoTexture

export default THREEx.VideoTexture
